import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import Autosuggest from 'react-autosuggest'
import { ah, ReduxWrapper, compose, QueryWrapper } from 'common-data/datahelpers'
import { Input, InputGroup, InputGroupAddon, Button } from 'reactstrap'
import _ from 'common-tools/LodashHelper'
import { componentGetCompareProps } from 'common-tools/index'
import { FAIcon } from './FAIcon'

class AutoSuggestBoxClassPlain extends React.Component {
  constructor (props) {
    super(props)

    this.clearSelectedSuggestion = this.clearSelectedSuggestion.bind(this)
    this.containerRef = React.createRef()
    this.state = {
      suggestionList: [],
      selectedSuggestion: {},
      onCheckError: null,
      openUpward: false
    }
  }

  static propTypes = buildPropTypes([

  ], {
    queryName: pt.string.isRequired,
    restoreValue: pt.any,
    hideClear: pt.bool.isRequired,
    extraDataMap: pt.oneOfType([
      pt.string,
      pt.arrayOf(pt.shape({
        Source: pt.string,
        Dest: pt.string
      })),
      pt.func
    ]),
    overrideSelectedSuggestion: pt.func,
    readonly: pt.bool
  })

  static defaultProps = {
    hideClear: false,
    readonly: false
  }

  onSuggestionsClearRequested () {
    this.setState({
      suggestionList: []
    })
  }

  componentDidMount () {
    const { restoreValue } = this.props

    if (restoreValue) {
      this.restoreSuggestion(restoreValue)
    }
  }

  componentDidUpdate (prevProps, prevState) {
    let restoreValue = componentGetCompareProps('restoreValue', this.props, prevProps, undefined)

    if (restoreValue.HasChanged) {
      if (!_.isNil(restoreValue.Current) && restoreValue.Current !== '') {
        this.restoreSuggestion(restoreValue.Current)
      } else {
        this.setState({
          selectedSuggestion: {}
        })
      }
    }
    // Check if the data has finished loading and update state
    if (prevProps.data.loadingGetSuggestions && !this.props.data.loadingGetSuggestions) {
      if (!this.state.suggestionList.length) {
        this.setState({
          suggestionList: this.props.data.suggestions || []
        })
      }
    }
  }

  fetchSuggestions = _.debounce((value) => {
    const { queryName, GetSuggestions, formCheckForSubmissionErrors, overrideSuggestionList } = this.props

    GetSuggestions({
      Name: queryName,
      Type: queryName,
      Text: value,
      RestoreValue: value
    }).then(({ data }) => {
      let newData = _.clone(data)
      if (_.isFunction(overrideSuggestionList)) {
        overrideSuggestionList(newData)
      }
      this.setState({
        suggestionList: newData || [],
        onCheckError: null
      })
    }).catch(formCheckForSubmissionErrors)
  }, 500)

  onSuggestionsFetchRequested ({ value, reason }) {
    if (reason === 'input-changed') {
      // Measure space below the input to decide if we should flip upward
      if (this.containerRef.current) {
        const rect = this.containerRef.current.getBoundingClientRect()
        const spaceBelow = window.innerHeight - rect.bottom
        this.setState({ openUpward: spaceBelow < 300 })
      }
      this.fetchSuggestions(value)
    }
  }

  onSuggestionSelected (event, { suggestion }) {
    if (suggestion.Value === 'No Matches' || suggestion.Value === 'Searching...') {
      event.stopPropagation()
      event.nativeEvent.stopImmediatePropagation()
      return
    }

    const { input: { onChange }, OnCheck, formSetFieldValue, meta: { form }, extraDataMap, id, overrideSelectedSuggestion } = this.props

    console.log(`Selected Suggestion Cleared: ${id}`)

    this.setState({
      selectedSuggestion: suggestion,
      onCheckError: null
    }, () => {
      onChange(suggestion.Value)
      if (_.isFunction(OnCheck)) {
        OnCheck(suggestion.ExtraData, this.clearSelectedSuggestion, (msg) => { this.setState({ onCheckError: msg }) })
      }
      if (_.isFunction(overrideSelectedSuggestion)) {
        overrideSelectedSuggestion(suggestion, this.clearSelectedSuggestion)
      }

      if (extraDataMap) {
        let extraData = suggestion.ExtraData || {}
        if (_.isString(extraDataMap)) {
          // just set this field to the Text of the selected value
          formSetFieldValue(form, extraDataMap, suggestion.Text)
        } else if (_.isArray(extraDataMap)) {
          for (var mapInfo of extraDataMap) {
            if (_.has(extraData, mapInfo.Source)) {
              formSetFieldValue(form, mapInfo.Dest, extraData[mapInfo.Source])
            }
          }
        } else if (_.isFunction(extraDataMap)) {
          extraDataMap(suggestion, extraData, (field, value) => {
            formSetFieldValue(form, field, value, 'set')
          })
        } else {
          throw Error('Invalid extraDataMap, must be a string, array, or function!')
        }
      }
    })
  }

  clearSelectedSuggestion () {
    const { input: { onChange }, formSetFieldValue, meta: { form }, extraDataMap } = this.props

    this.setState({
      selectedSuggestion: {},
      onCheckError: null
    }, () => {
      onChange(null)
      console.log('ClearClicked!')
      if (extraDataMap) {
        if (_.isString(extraDataMap)) {
          // just set this field to the Text of the selected value
          formSetFieldValue(form, extraDataMap, null)
        } else if (_.isArray(extraDataMap)) {
          for (var mapInfo of extraDataMap) {
            formSetFieldValue(form, mapInfo.Dest, mapInfo.ClearValue)
          }
        } else if (_.isFunction(extraDataMap)) {
          extraDataMap({}, {}, (field, value) => {
            formSetFieldValue(form, field, value, 'clear')
          })
        } else {
          throw Error('Invalid extraDataMap, must be a string, array, or function!')
        }
      }
    })
  }

  restoreSuggestion (value) {
    const { queryName, GetSuggestions, formCheckForSubmissionErrors } = this.props

    GetSuggestions({
      Name: queryName,
      Type: queryName,
      Text: null,
      Value: value
    }).then(({ data }) => {
      this.setState({
        selectedSuggestion: data[0] || {}
      })
    }).catch(formCheckForSubmissionErrors)
  }

  render () {
    const { data, hideClear, children, readonly: lreadonly, id, ...rest } = this.props
    const { suggestionList, selectedSuggestion, onCheckError, openUpward } = this.state

    let suggestions = suggestionList

    if (data.loadingGetSuggestions) {
      suggestions = [{ Value: 'Searching...' }]
    } else {
      if (suggestionList.length === 0) {
        suggestions = [{ Value: 'No Matches' }]
      }
    }

    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, onSuggestionSelected, name, placeHolder = 'Start typing to search', loading, readonly }) => {
          const inner = (() => {
            if (selectedSuggestion.Value) {
              if (data.loadingGetSuggestions) {
                return <Input type='text' key={id} readOnly name={`textsuggest${id}`} id={`textsuggest${id}`} value={'Fetching...'} />
              } else {
                if (lreadonly || hideClear || readonly) {
                  return <Input type='text' readOnly name={`viewsuggest${name}`} id={`viewsuggest${name}`} value={selectedSuggestion.Text} />
                } else {
                  return (
                    <div style={{ position: 'relative', display: 'flex', alignItems: 'center', width: '100%' }}>
                      <Input
                        type='text'
                        key={id}
                        readOnly
                        name={`textsuggest${id}`}
                        id={`textsuggest${id}`}
                        value={selectedSuggestion.Text || value || ''}
                        style={{ paddingRight: '2.25rem' }}
                      />
                      <button
                        type='button'
                        onClick={this.clearSelectedSuggestion.bind(this)}
                        title='Clear selection'
                        aria-label='Clear selection'
                        style={{
                          position: 'absolute',
                          right: '6px',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          background: 'transparent',
                          border: 'none',
                          padding: '4px 6px',
                          cursor: 'pointer',
                          color: '#6F6F6F',
                          fontSize: '0.9rem',
                          lineHeight: 1,
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: '50%',
                          zIndex: 5,
                          outline: 'none',
                          transition: 'color 0.15s ease-in-out, background-color 0.15s ease-in-out'
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.color = '#FF0000'
                          e.currentTarget.style.backgroundColor = 'rgba(255,0,0,0.1)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.color = '#6F6F6F'
                          e.currentTarget.style.backgroundColor = 'transparent'
                        }}
                      >
                        <FAIcon name='times' />
                      </button>
                    </div>
                  )
                }
              }
            } else {
              return (
                <div ref={this.containerRef} style={{ position: 'relative' }}>
                  {/* inner Autosuggest block — ref lets us measure position for upward flip */}
                  {(()  => {
                    const hasValue = !_.isNil(value) && value !== ''
                    const showClearIcon = hasValue && !lreadonly && !hideClear && !readonly

                    return (
                      <div style={{ position: 'relative', width: '100%' }}>
                        <Autosuggest
                          inputProps={{
                            onChange: (event, props) => {
                              const { newValue } = props
                              onChange(newValue)
                              if (onCheckError) this.setState({ onCheckError: null })
                            },
                            value: _.isString(value) ? value : _.isNil(value) ? '' : `${value}`,
                            placeholder: placeHolder,
                            disabled: loading,
                            invalid: showError || !!onCheckError,
                            className: 'form-control',
                            style: showClearIcon ? { paddingRight: '2.25rem' } : undefined,
                            onBlur: () => {
                              console.log('onBlur')
                              if (!selectedSuggestion.Value) {
                                onChange(null)
                              }
                            }
                          }}
                          key={id}
                          id={`textsuggest${id}`}
                          name={`textsuggest${id}`}
                          suggestions={suggestions}
                          renderSuggestion={
                            _.isFunction(children)
                              ? children
                              : (suggestion) =>
                                <div>
                                  {suggestion.Text || suggestion.Value || '???'}
                                </div>
                          }
                          renderSuggestionsContainer={({ containerProps, children: dropdownChildren }) => (
                            <div
                              {...containerProps}
                              style={openUpward ? {
                                position: 'absolute',
                                bottom: '100%',
                                top: 'auto',
                                marginBottom: '2px',
                                marginTop: 0,
                                width: '100%',
                                zIndex: 9999,
                                background: '#fff',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                boxShadow: '0 -2px 8px rgba(0,0,0,0.15)'
                              } : {
                                position: 'absolute',
                                top: '100%',
                                marginTop: '2px',
                                width: '100%',
                                zIndex: 9999,
                                background: '#fff',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
                              }}
                            >
                              {dropdownChildren}
                            </div>
                          )}
                          getSuggestionValue={suggestion => suggestion.Text}
                          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested.bind(this)}
                          onSuggestionSelected={this.onSuggestionSelected.bind(this)}
                          onSuggestionsClearRequested={this.onSuggestionsClearRequested.bind(this)}
                        />
                        {showClearIcon && (
                          <button
                            type='button'
                            onClick={() => {
                              this.clearSelectedSuggestion()
                            }}
                            title='Clear input'
                            aria-label='Clear input'
                            style={{
                              position: 'absolute',
                              right: '6px',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              background: 'transparent',
                              border: 'none',
                              padding: '4px 6px',
                              cursor: 'pointer',
                              color: '#6F6F6F',
                              fontSize: '0.9rem',
                              lineHeight: 1,
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              borderRadius: '50%',
                              zIndex: 5,
                              outline: 'none',
                              transition: 'color 0.15s ease-in-out, background-color 0.15s ease-in-out'
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.color = '#FF0000'
                              e.currentTarget.style.backgroundColor = 'rgba(255,0,0,0.1)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.color = '#6F6F6F'
                              e.currentTarget.style.backgroundColor = 'transparent'
                            }}
                          >
                            <FAIcon name='times' />
                          </button>
                        )}
                      </div>
                    )
                  })()}
                </div>
              )
            }
          })()
          return (
            <React.Fragment>
              {inner}
              {onCheckError ? <span style={{ color: '#FF0000', fontSize: '0.85em', display: 'block', marginTop: '0.25rem' }}>{onCheckError}</span> : null}
            </React.Fragment>
          )
        }}
      </FieldLayoutBox>
    )
  }
}

const autoSuggestBoxes = new Map()

const BuildAutoSuggestBox = (name) => {
  let ret = autoSuggestBoxes.get(name)

  if (!ret) {
    ret = compose(
      ReduxWrapper([

      ], [
        ah.formCheckForSubmissionErrors,
        ah.formSetFieldValue
      ]),
      QueryWrapper({
        key: `AutoSuggest`,
        actions: [
          {
            url: '/AutoComplete/Get',
            prop: 'GetSuggestions',
            map: false
          }
        ]
      })
    )(AutoSuggestBoxClassPlain)
    autoSuggestBoxes.set(name, ret)
  }

  return ret
}

export const AutoSuggestBox = ({ parse, format, fieldType, ...rest }) => {
  return <Field parse={fieldType ? FieldValueParser(fieldType) : parse}
    format={fieldType ? FieldValueFormatter(fieldType) : format}
    {...rest}
  component={BuildAutoSuggestBox(rest.name)} /> } // eslint-disable-line
export default AutoSuggestBox
